module.exports = __webpack_public_path__ + "img/arrow-black.cdc50ae8.svg";